import {fragmentId} from "./organizationSettingsConstants";

export default function() {
    return {
        sections: [
            {
                name: fragmentId.INFO,
                label: {
                    COMPANY_INFORMATION: 'Company Information',
                    CONTACT_EMAIL: 'Contact Email',
                    CONTRACTED_VOLUME: 'Contracted volume',
                    CSM: 'Customer success manager',
                    VISIBILITY: 'Visibility',
                    HIDE_IN_MOBILE: 'Hide in mobile',
                    TICKET_BUDGET: 'Ticket budget',
                    USED_TICKETS: 'Used tickets',
                    PRODUCTS: 'Products',
                    PAY_AGENT_ON_SKIP: 'Pay agent on skip',
                    TEAMS_SETTINGS: 'Teams settings',
                    TRENDS_SETTINGS: 'Trends settings',
                    TRENDS_SETTINGS_UNAVAILABLE: 'This organization is not linked to Trends.',
                }
            },
            {
                name: fragmentId.QUEUE,
                label: {
                    TRIAGE_AND_QUEUE_MANAGEMENT: 'Triage and Queue Management',
                    MESSAGE_RETENTION_DURATION: 'Message retention duration',
                    ENABLE_REQUIRED_TAGS: 'Enable required tags'
                }
            },
            {
                name: 'expert',
                label: {
                    EXPERT_MANAGEMENT: 'Expert Management',
                    SCHEDULES: 'Schedules'
                }
            },
            {
                name: fragmentId.NOTIFICATIONS,
                label: {
                    NOTIFICATIONS: 'Notifications',
                    WEEKLY_METRICS_EMAIL: 'Weekly metrics email',
                    SHOPIFY_REVENUE_TRACKING: 'Shopify revenue tracking',
                    GORGIAS_REVENUE_TRACKING: 'Gorgias revenue tracking',
                    EMAIL_ESCALATION: 'Escalations (Email)',
                    PRESALE_REMAINDER: 'Proactive presale',
                }
            },
            {
                name: fragmentId.DATA_SOURCES,
                label: {
                    ACTIVE_DATA_SOURCES: 'Active Data Sources',
                    VISIBILITY: 'Visibility',
                    GORGIAS: 'Gorgias',
                    CUSTOM_FIELDS_ON_CLOSE: 'Custom fields on close',
                    TRENDS: 'Trends',
                    TRENDS_READY_TO_MIGRATE: 'TRENDS (READY TO MIGRATE)',
                    MIGRATE_TO_TEAMS: 'Migrate to Teams',
                    STATUS: 'Status',
                    LAST_MESSAGE: 'Last message',
                    NO_MESSAGES: 'No messages',
                    GENERATE_RESPONSES: 'Response Generation Enabled',
                    COPY_MESSAGES_TO_TEAMS: 'Copy messages to Teams + Generate Responses',
                    MESSAGE_COUNT: 'Number of messages',
                    COPY: 'Copy',
                }
            },
            {
                name: fragmentId.MSG_DATA_SOURCES,
                label: {
                    CUSTOM_FIELDS: 'Custom fields',
                    TRENDS: 'Trends',
                    ACTIVE: 'Active',
                    FETCH_AD_POSTS: 'Fetch ad posts',
                    AD_POLLING_V2: 'Ad polling (v2)',
                    INTERNAL_NOTES: 'Internal notes',
                    SEND_INTERNAL_NOTES_TO_PIPELINE: 'Send internal notes to Teams',
                    ACTION_BY_ASSIGNEE: 'Action by assignee',
                    FETCH_BACKLOG: 'Fetch backlog',
                    FETCH: 'Fetch',
                    GORGIAS_VIEWS_SETUP: 'Gorgias Views Set-up',
                    OPEN: 'Open',
                    SUPPORT_EMAIL: 'Support email',
                    ORG_SUPPORT_EMAIL: 'Org support email',
                    SAVE: 'Save',
                    INTERNAL_NOTES_TEAMS: 'Internal notes (Teams)',
                    AUTO_ACTION_INTERNAL_NOTES: 'Auto-action internal notes',
                    AUTO_ACTION_INTERNAL_NOTES_ALL: 'All',
                    AUTO_ACTION_INTERNAL_NOTES_NONE: 'None',
                    AUTO_ACTION_INTERNAL_NOTES_SELECTED: 'Selected',
                    AUTO_ACTION_INTERNAL_NOTES_EMAILS: "Author's exact emails",
                    AUTO_ACTION_INTERNAL_NOTES_SUFFIXES: "Author's email suffixes",
                    ADD_EMAIL_PLACEHOLDER: 'Type an email and press Enter',
                    ADD_SUFFIX_PLACEHOLDER: 'Type a suffix and press Enter',
                }
            },
            {
                name: fragmentId.BLACKLISTS,
                label: {
                    BLACKLISTS: 'Blacklists',
                }
            },
            {
                name: fragmentId.AUTO_ACTIONS,
                label: {
                    AUTO_ACTIONS: 'Auto Actions',
                }
            },
            {
                name: fragmentId.RESPONSES,
                label: {
                    MESSAGE_RESPONSES: 'Message Responses',
                    AUTO_ACTION: 'AUTO ACTION IS ACTIVE',
                    SKIP_ENABLED: 'IS SKIP ENABLED',
                    AUTO_REPLY_ENABLED: 'IS AUTO-REPLY ENABLED',
                    TOPICS: 'TOPICS',
                    AUTO_REPLIES: 'AUTO REPLIES',
                    FIRST_RESPONSES: 'ENABLE AUTOMATIC FIRST RESPONSES WHEN QUEUE IS BUSY',
                    AUTO_RESPONDER: 'MINIMUM QUEUE VOLUME (MESSAGES) TO TRIGGER AUTO-RESPONDER',
                    FIRST_RESPONSE_FOOTER: 'FIRST RESPONSE FOOTER'
                }
            },
            {
                name: fragmentId.SUGGESTED_RESPONSES,
                label: {
                    SUGGESTED_RESPONSES: 'Generated Replies',
                    PROMPT: 'Prompt',
                    PROMPT_PLACEHOLDER: "Describe the style of expected replies, organization's policies, ...",
                    DEFAULT_PROMPT_IN_USE: 'This organization uses the default prompt for generated replies. Add a variant to customize it.',
                    ADD_VARIANT: 'Add prompt variant',
                    ADD_VARIANT_PLACEHOLDER: 'Choose Default or a handle type…',
                    ALL_VARIANTS_ADDED: 'All variants have a prompt',
                    DELETE_PROMPT: 'Delete prompt',
                    LAST_UPDATED: 'Last updated',
                    NOT_SAVED: 'Not saved yet',
                    NO_ORGANIZATION_SELECTED: 'Select an organization to manage its generated replies prompts.',
                    NOT_LINKED_TO_TRENDS: 'This organization is not linked to Trends.',
                }
            },
            {
                name: fragmentId.FEATURE_FLAGS,
                label: {
                    FEATURE_FLAGS: 'Feature Flags',
                    INBOX_2_0: 'Inbox 2.0',
                    INBOX_2_0_TOOLTIP: "If enabled, the company's admins are linked to the new Inbox instead of the old one. They see the change after they log in again.",
                    NO_ORGANIZATION_SELECTED: 'Select an organization to manage its feature flags.',
                }
            },
            {
                name: fragmentId.OFF_BOARD,
                label: {
                    OFF_BOARD: 'Offboard',
                    DISABLE_COMPANY: 'Disable company',
                    REMOVE_COMPANY: 'Remove company'
                }
            },
        ]
    }
}